import { frontendURL } from '../../../helper/URLHelper';
import DocalHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/docal'),
      name: 'docal_home',
      component: DocalHome,
      roles: ['administrator', 'agent'],
    },
  ],
};
